import { LOCALSTORAGE_TOKEN_KEY } from '@/constants'
import { VuexModule, Module, Mutation, Action, store, ApiClient } from './helpers'
import { Appointments } from './Appointments'
import { Resources } from './Resource'
import { Employees } from './Employee'
import { Locations } from './Locations'
import { Messages } from './Messages'
import { Templates } from './Templates'

@Module
class UserStateModule extends VuexModule {
  // State
  id: number | null = null
  email: string = ''
  location: string = ''
  token: string | null = ''
  attemptedToAuthenticate: boolean = false

  /**
   * Login with username/password and add credentials to the store
   * @param param Send username/password credentials and get a token
   */
  @Action async LOGIN({ email, password }: { email: string, password: string }) {
    const { data } = await ApiClient.post('/api/users/sign_in', { email, password })
    this.AUTHENTICATE(data.auth_token)
    this.HANDSHAKE()
    // TODO Handle Error
  }

  /**
   * Remove all credentials and clear the token from cookies
   */
  @Action async LOGOUT() {
    Locations.RESET()
    Templates.RESET()
    this.logoutMutation()
  }

  @Mutation logoutMutation() {
    this.token = null
    this.attemptedToAuthenticate = true
    localStorage.removeItem(LOCALSTORAGE_TOKEN_KEY) // TODO Connect to API to logout
  }

  /**
   * Check if we have an auth token, else show the login screen
   * @param token the token if we want to override it
   */
  @Action async SETUP_AUTH_TOKEN(token?: string | null) {
    token = token || localStorage.getItem(LOCALSTORAGE_TOKEN_KEY)
    if (token === 'undefined') {
      token = null
    }
    if (token) {
      this.AUTHENTICATE(token)
      this.HANDSHAKE()
    } else {
      // Not authenticated, show the login form
    }
    this.AFTER_AUTHENTICATION_ATTEMPT()
  }

  /**
   * Trigger a load of all other basic info needed
   */
  @Action HANDSHAKE() {
    Locations.GET_LOCATIONS()
    Messages.GET_MESSAGES()
    Appointments.GET_APPOINTMENTS()
    Resources.GET_RESOURCES()
    Employees.GET_EMPLOYEES()
    Templates.GET_TEMPLATES()
  }

  @Mutation AUTHENTICATE(authToken: string) {
    this.token = authToken || 'fakeToken'
    ApiClient.authenticate(this.token)
  }

  @Mutation AFTER_AUTHENTICATION_ATTEMPT() {
    this.attemptedToAuthenticate = true
  }
}

export const UserState = new UserStateModule({ store, name: 'UserState' })
